<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon">
    <mat-icon class="mdi-24px" fontIcon="mdi-account-multiple"></mat-icon>
  </div>
  <mat-form-field style="width: 300px">
    <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event.target.value)" placeholder="Search" />
    @if (filterString) {
    <button mat-icon-button matSuffix (click)="applyFilter('')" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="button-end">
    <mat-paginator #paginator [pageIndex]="0" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
  </div>
</div>

<div class="table-container">
  @if (addingNewUser) {
  <div class="new-user-row">
    <div class="new-user-cell">
      <mat-form-field>
        <input matInput placeholder="User ID" [(ngModel)]="newUser.id" matTooltip="Must be a valid Guid" />
      </mat-form-field>
    </div>
    <div class="new-user-cell">
      <mat-form-field>
        <input matInput placeholder="User Name" [(ngModel)]="newUser.name"
          matTooltip="Must have a minimum of 4 characters" />
      </mat-form-field>
    </div>
    <div class="new-user-cell">
      <button mat-icon-button (click)="addNewUser(true)"
        [disabled]="!newUser.id || !newUser.name || newUser.name.length < 4">
        <mat-icon class="mdi-24px" fontIcon="mdi-account-plus" matTooltip="Add this user"></mat-icon>
      </button>
      <button mat-icon-button (click)="addNewUser(false)" matTooltip="Cancel">
        <mat-icon class="mdi-24px" fontIcon="mdi-account-remove"></mat-icon>
      </button>
    </div>
  </div>
  }

  <table mat-table [dataSource]="userDataSource" matSort>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-icon-button (click)="addingNewUser = true; $event.stopPropagation()" title="Add User">
          <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
        ID
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button ngxClipboard [cbContent]="element.id" (click)="$event.stopPropagation()"
          title="Copy:  {{ element.id }}">
          <mat-icon class="mdi-24px" fontIcon="mdi-content-copy"></mat-icon>
        </button>
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field subscriptSizing="dynamic">
          <mat-select [disabled]="!canEdit" [value]="element.roleId == null ? '' : element.roleId"
            (selectionChange)="updateRole(element, $event)">
            <mat-option value="">None Locally</mat-option>
            @for (role of roles$ | async; track trackById($index, role)) {
              <mat-option [value]="role.id">{{ role.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (canEdit) {
          <button mat-icon-button (click)="deleteUser(element); $event.stopPropagation()"
            title="Delete User">
            <mat-icon class="mdi-24px" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (isLoading) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
  }
</div>
